"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _AdaptiveCardRenderer = _interopRequireDefault(require("./AdaptiveCardRenderer"));

var _useAdaptiveCardsPackage = _interopRequireDefault(require("../hooks/useAdaptiveCardsPackage"));

var _botframeworkWebchatComponent = require("botframework-webchat-component");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var useDirection = _botframeworkWebchatComponent.hooks.useDirection;

function stripSubmitAction(card) {
  if (!card.actions) {
    return card;
  } // Filter out HTTP action buttons


  var nextActions = card.actions.filter(function (action) {
    return action.type !== 'Action.Submit';
  }).map(function (action) {
    return action.type === 'Action.ShowCard' ? _objectSpread({}, action, {
      card: stripSubmitAction(action.card)
    }) : action;
  });
  return _objectSpread({}, card, {
    nextActions: nextActions
  });
}

function updateRTLInline(element, rtl, adaptiveCardsPackage) {
  if (element instanceof adaptiveCardsPackage.Container) {
    element.rtl = rtl;
  } // Tree traversal to add rtl boolean to child elements


  if (element.getItemAt && element.getItemCount) {
    var count = element.getItemCount();

    for (var index = 0; index < count; index++) {
      var child = element.getItemAt(index);
      updateRTLInline(child, rtl, adaptiveCardsPackage);
    }
  }
}

var AdaptiveCardAttachment = function AdaptiveCardAttachment(_ref) {
  var content = _ref.attachment.content;

  var _useAdaptiveCardsPack = (0, _useAdaptiveCardsPackage.default)(),
      _useAdaptiveCardsPack2 = (0, _slicedToArray2.default)(_useAdaptiveCardsPack, 1),
      adaptiveCardsPackage = _useAdaptiveCardsPack2[0];

  var AdaptiveCard = adaptiveCardsPackage.AdaptiveCard;

  var _useDirection = useDirection(),
      _useDirection2 = (0, _slicedToArray2.default)(_useDirection, 1),
      direction = _useDirection2[0];

  var _useMemo = (0, _react.useMemo)(function () {
    if (content) {
      var _card = new AdaptiveCard();

      var errors = []; // TODO: [P3] Move from "onParseError" to "card.parse(json, errors)"

      AdaptiveCard.onParseError = function (error) {
        return errors.push(error);
      };

      _card.parse(stripSubmitAction(_objectSpread({
        version: '1.0'
      }, (0, _typeof2.default)(content) === 'object' ? content : {}))); // Add rtl to Adaptive Card and child elements if Web Chat direction is 'rtl'


      updateRTLInline(_card, direction === 'rtl', adaptiveCardsPackage);
      AdaptiveCard.onParseError = null;
      return {
        card: _card,
        errors: errors
      };
    }

    return {};
  }, [AdaptiveCard, adaptiveCardsPackage, content, direction]),
      card = _useMemo.card;

  return !!card && _react.default.createElement(_AdaptiveCardRenderer.default, {
    adaptiveCard: card
  });
};

var _default = AdaptiveCardAttachment;
exports.default = _default;
AdaptiveCardAttachment.propTypes = {
  attachment: _propTypes.default.shape({
    content: _propTypes.default.any.isRequired
  }).isRequired
};